// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// // Import Lexend font weights
// import '@fontsource/lexend/300.css'; // Light
// import '@fontsource/lexend/400.css'; // Regular
// import '@fontsource/lexend/500.css'; // Medium
// import '@fontsource/lexend/600.css'; // Semi-bold
// import '@fontsource/lexend/700.css'; // Bold

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './theme/ThemeContext';

// Import Lexend font weights
import '@fontsource/lexend/300.css'; // Light
import '@fontsource/lexend/400.css'; // Regular
import '@fontsource/lexend/500.css'; // Medium
import '@fontsource/lexend/600.css'; // Semi-bold
import '@fontsource/lexend/700.css'; // Bold

const root = ReactDOM.createRoot(document.getElementById('root'));

// REMOVED STRICT MODE - It was causing iframe to remount/reload
// Strict Mode is useful for development, but incompatible with iframes that shouldn't reload
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();